// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"541":"sidebar","562":"accounts"}[chunkId] + "." + {"541":"e821192d","562":"bcde2c7b"}[chunkId] + ".chunk.css";
};